import * as actionTypes from './actionTypes';

export const loadLessonByLessonId = {
  signal: (lessonId, isDemo) => ({
    type: actionTypes.LOAD_LESSON_BY_LESSON_ID_SIGNAL,
    payload: { lessonId, isDemo },
  }),
  request: (lessonId, isDemo) => ({
    type: actionTypes.LOAD_LESSON_BY_LESSON_ID_REQUEST,
    payload: { lessonId, isDemo },
  }),
  success: (lessonId, isDemo, lesson) => ({
    type: actionTypes.LOAD_LESSON_BY_LESSON_ID_SUCCESS,
    payload: { lessonId, isDemo, lesson },
  }),
  failure: (lessonId, isDemo, failureReason) => ({
    type: actionTypes.LOAD_LESSON_BY_LESSON_ID_FAILURE,
    payload: { lessonId, isDemo, failureReason },
  }),
};

export const loadQuizStatsByLessonId = {
  signal: (lessonId) => ({
    type: actionTypes.LOAD_QUIZ_STATS_BY_LESSON_ID_SIGNAL,
    payload: { lessonId },
  }),
  request: (lessonId) => ({
    type: actionTypes.LOAD_QUIZ_STATS_BY_LESSON_ID_REQUEST,
    payload: { lessonId },
  }),
  success: (lessonId, quizStats) => ({
    type: actionTypes.LOAD_QUIZ_STATS_BY_LESSON_ID_SUCCESS,
    payload: { lessonId, quizStats },
  }),
  failure: (lessonId, failureReason) => ({
    type: actionTypes.LOAD_QUIZ_STATS_BY_LESSON_ID_FAILURE,
    payload: { lessonId, failureReason },
  }),
};

export const loadQuizAttemptsByLessonId = {
  signal: (lessonId) => ({
    type: actionTypes.LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_SIGNAL,
    payload: { lessonId },
  }),
  request: (lessonId) => ({
    type: actionTypes.LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_REQUEST,
    payload: { lessonId },
  }),
  success: (lessonId, quizAttempts) => ({
    type: actionTypes.LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_SUCCESS,
    payload: { lessonId, quizAttempts },
  }),
  failure: (lessonId, failureReason) => ({
    type: actionTypes.LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_FAILURE,
    payload: { lessonId, failureReason },
  }),
};

export const saveQuizAttempt = {
  signal: (lessonId, questionId, quizAttempt, callback, onError) => ({
    type: actionTypes.SAVE_QUIZ_ATTEMPT_SIGNAL,
    payload: { lessonId, questionId, quizAttempt, callback, onError },
  }),
  request: (lessonId, questionId, quizAttempt) => ({
    type: actionTypes.SAVE_QUIZ_ATTEMPT_REQUEST,
    payload: { lessonId, questionId, quizAttempt },
  }),
  success: (lessonId, questionId, quizAttempt) => ({
    type: actionTypes.SAVE_QUIZ_ATTEMPT_SUCCESS,
    payload: { lessonId, questionId, quizAttempt },
  }),
  failure: (lessonId, questionId, quizAttempt, failureReason) => ({
    type: actionTypes.SAVE_QUIZ_ATTEMPT_FAILURE,
    payload: { lessonId, questionId, quizAttempt, failureReason },
  }),
};

export const loadChunkVisitsByLessonId = {
  signal: (lessonId) => ({
    type: actionTypes.LOAD_CHUNK_VISITS_BY_LESSON_ID_SIGNAL,
    payload: { lessonId },
  }),
  request: (lessonId) => ({
    type: actionTypes.LOAD_CHUNK_VISITS_BY_LESSON_ID_REQUEST,
    payload: { lessonId },
  }),
  success: (lessonId, chunkVisits) => ({
    type: actionTypes.LOAD_CHUNK_VISITS_BY_LESSON_ID_SUCCESS,
    payload: { lessonId, chunkVisits },
  }),
  failure: (lessonId, failureReason) => ({
    type: actionTypes.LOAD_CHUNK_VISITS_BY_LESSON_ID_FAILURE,
    payload: { lessonId, failureReason },
  }),
};

export const recordChunkVisit = {
  signal: (lessonId, chunkId) => ({
    type: actionTypes.RECORD_CHUNK_VISIT_SIGNAL,
    payload: { lessonId, chunkId },
  }),
  request: (lessonId, chunkId) => ({
    type: actionTypes.RECORD_CHUNK_VISIT_REQUEST,
    payload: { lessonId, chunkId },
  }),
  success: (lessonId, chunkId, chunkVisit) => ({
    type: actionTypes.RECORD_CHUNK_VISIT_SUCCESS,
    payload: { lessonId, chunkId, chunkVisit },
  }),
  failure: (lessonId, chunkId, failureReason) => ({
    type: actionTypes.RECORD_CHUNK_VISIT_FAILURE,
    payload: { lessonId, chunkId, failureReason },
  }),
};

// Actions for success measure responses
export const loadSuccessMeasureResponsesByLessonId = {
  signal: (lessonId) => ({
    type: actionTypes.LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_SIGNAL,
    payload: { lessonId },
  }),
  request: (lessonId) => ({
    type: actionTypes.LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_REQUEST,
    payload: { lessonId },
  }),
  success: (lessonId, successMeasureResponses) => ({
    type: actionTypes.LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_SUCCESS,
    payload: { lessonId, successMeasureResponses },
  }),
  failure: (lessonId, failureReason) => ({
    type: actionTypes.LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_FAILURE,
    payload: { lessonId, failureReason },
  }),
};

export const recordSuccessMeasureResponse = {
  signal: (
    lessonId,
    profileId,
    successMeasureId,
    value,
    successNavigateUrl
  ) => ({
    type: actionTypes.RECORD_SUCCESS_MEASURE_RESPONSE_SIGNAL,
    payload: {
      lessonId,
      profileId,
      successMeasureId,
      value,
      successNavigateUrl,
    },
  }),
  request: (successMeasureId, value) => ({
    type: actionTypes.RECORD_SUCCESS_MEASURE_RESPONSE_REQUEST,
    payload: { successMeasureId, value },
  }),
  success: (
    lessonId,
    profileId,
    successMeasureId,
    value,
    successMeasureResponse
  ) => ({
    type: actionTypes.RECORD_SUCCESS_MEASURE_RESPONSE_SUCCESS,
    payload: {
      lessonId,
      profileId,
      successMeasureId,
      value,
      successMeasureResponse,
    },
  }),
  failure: (lessonId, profileId, successMeasureId, value, failureReason) => ({
    type: actionTypes.RECORD_SUCCESS_MEASURE_RESPONSE_FAILURE,
    payload: { lessonId, profileId, successMeasureId, value, failureReason },
  }),
};
